export const DatabaseEngine = {
  postgres: 'postgres',
  sqlite: 'sqlite',
} as const

export type DatabaseEngineType = (typeof DatabaseEngine)[keyof typeof DatabaseEngine]
